import { defineComponent } from "vue";

/**
 * 渲染 `Collect` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Collect = defineComponent({
	name: "Collect",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M382.528 354.176l100.992-201.472a32 32 0 0 1 57.152-0.128l102.4 201.792a32 32 0 0 0 24.064 17.152l227.712 32.448a32 32 0 0 1 17.6 54.848l-164.992 157.888a32 32 0 0 0-9.408 28.8l39.04 218.432a32 32 0 0 1-46.336 33.984L526.72 791.68a32 32 0 0 0-29.568 0l-203.904 106.24a32 32 0 0 1-46.272-34.112l39.296-218.24a32 32 0 0 0-9.408-28.8L111.68 458.752a32 32 0 0 1 17.6-54.784l229.12-32.512a32 32 0 0 0 24.128-17.28zM512.32 238.08L439.68 382.912q-22.528 44.928-72.32 52.032l-163.84 23.168 117.504 112.32q37.312 35.648 28.16 86.4l-27.712 154.176 146.048-76.16q44.352-23.04 88.704 0l146.304 76.224-27.52-154.368q-9.088-50.624 28.16-86.208l117.376-112.448-162.496-23.168q-49.472-7.04-72.064-51.584L512.32 238.08z" />
			</svg>
		);
	},
});

export default Collect;
